import React from 'react';
import { Card } from 'react-bootstrap';
import { Button, Col, Row } from 'react-bootstrap';

import ComplementoCartaPorteBaseResumen from './ComplementoCartaPorteBaseResumen';
import ComplementoCartaPorteMercanciasResumen from './ComplementoCartaPorteMercanciasResumen';
import ComplementoCartaPorteUbicacionesResumen from './ComplementoCartaPorteUbicacionesResumen';
import ComplementoCartaPorteAutotransporteResumen from './ComplementoCartaPorteAutotransporteResumen';
import ComplementoCartaPorteFiguraTransporteResumen from './ComplementoCartaPorteFiguraTransporteResumen';
import ComplementoCartaPorteRegimenesAduanerosResumen from './ComplementoCartaPorteRegimenesAduanerosResumen';

const ComplementoCartaPorteResumen = ({ data = {}, onEdit, onDelete }) => {
  const handleOnDelete = () => {
    onDelete('CartaPorte');
  };

  const handleOnEdit = () => {
    onEdit('CartaPorte', data);
  };

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          <div className="d-block mt-3 mb-2">Carta Porte, Versión {data.Version}</div>
        </Card.Subtitle>

        <ComplementoCartaPorteBaseResumen data={data} />

        <ComplementoCartaPorteRegimenesAduanerosResumen data={data} />

        <ComplementoCartaPorteUbicacionesResumen data={data} />

        <ComplementoCartaPorteMercanciasResumen data={data} />

        <ComplementoCartaPorteAutotransporteResumen data={data} />

        <ComplementoCartaPorteFiguraTransporteResumen data={data} />

        <Row className="pt-3">
          <Col>
            <Button
              variant="danger"
              className="mr-3"
              onClick={handleOnDelete}
            >
              Quitar
            </Button>

            <Button
              variant="secondary"
              onClick={handleOnEdit}
            >
              Editar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ComplementoCartaPorteResumen;
